import { APIBase } from "./apibase";

export class ManualsAPI extends APIBase {
  access(callback) {
    return this.send({
      command: "manuals",
      method: "GET",
      refresh_interval: 0,
      identification: {},
      custom_callback: callback
    });
  }
}
